(function ($) {
    /* global jQuery */
    /* global Swiper */
    /* eslint camelcase: 0 */
    /* eslint no-var: 0 */
    var values = {
        cs: {
            fortnite: ['divide', 0.252525],
            valorant: ['divide', 3.181818],
            cs: ['multiple', 1],
        },
        fortnite: {
            fortnite: ['multiple', 1],
            valorant: ['divide', 12.6],
            cs: ['multiple', 0.252525],
        },
        valorant: {
            fortnite: ['multiple', 12.6],
            valorant: ['multiple', 1],
            cs: ['multiple', 3.181818],
        }
    };

    var selected_game_from_index = false;
    var selected_game_to_index = false;
    var $sectionConverter = $('.calculator-section');
    var $input = $('.input-sensitivity');
    var $resGameName = $('.res-game');
    var $resGameCalculator = $('.res-game-name');
    var $resVal = $('.res-val__calculator');
    var url = window.location.href;

    // Capitalize string
    var capitalize = function (s) {
        if (typeof s !== 'string') {
            return '';
        }
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) === variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        return false;
    }

    // Init selection on page load
    if ($('.swiper-slide.selected', $('.swiper-games').first()).length) {
        var name = $('.swiper-slide.selected', $('.swiper-games').first()).attr('data-game-name');
        selected_game_from_index = name;
    }

    // user visit converter page with preselected game
    if (!selected_game_from_index && getQueryVariable('game')) {
        selected_game_from_index = getQueryVariable('game');
    }

    $('.swiper-games').each(function (index) {
        var $slider = $(this);
        var $sliderParent = $slider.closest('.slider-games');
        var $sliderItem = $('.swiper-slide', $sliderParent);
        var $next = $('.swiper-button-next', $sliderParent);
        var $prev = $('.swiper-button-prev', $sliderParent);
        var navigation = function () {
            var sliderLength = $sliderItem.length;
            if (sliderLength <= 3) {
                $next.hide();
                $prev.hide();
                return false;
            }
            return {
                nextEl: $next.get(0),
                prevEl: $prev.get(0),
            };
        };

        var slider = new Swiper(this, {
            slidesPerView: 'auto',
            // spaceBetween: 45,
            simulateTouch: false,
            // allowTouchMove: false,
            navigation: navigation(),
        });

        // Add/Remove selected class + Slider validation
        $sliderParent.on('click', '.swiper-slide', function () {
            var $this = $(this);
            var thisName = $this.attr('data-game-name');
            $sliderItem.removeClass('selected');
            $this.addClass('selected');
            if (index === 0) {
                selected_game_from_index = thisName;
            } else {
                selected_game_to_index = thisName;
            }
            if (thisName === 'cs') {
                $resGameCalculator.html('CS: GO <span>eDPI</span>');
            } else {
                $resGameCalculator.html(capitalize(thisName) + ' <span>eDPI</span>');
            }
            // Don't remove
            // console.log(selected_game_to_index)
            //
            // console.log($this.index(), selected_game_from_index, selected_game_to_index);
            // validateGames();
        });

    });

    // Input validation
    var validateInput = function (target) {
        var value = target.val();
        if (value === '' || value.match(/[^0-9.]/g)) {
            return true;
        }
        return false;
    };

    $input.on('keyup', function () {
        var $this = $(this);
        if ($this.val() !== '' && validateInput($this)) {
            $this.addClass('invalid');
        } else {
            $this.removeClass('invalid');
        }
    });

    var addConvertToGameClass = function (itemSlide, resGame) {
        if (itemSlide === 'fortnite') {
            resGame.removeClass('cs valorant');
            resGame.addClass('fortnite');
        } else if (itemSlide === 'cs') {
            resGame.removeClass('fortnite valorant');
            resGame.addClass('cs');
        } else if (itemSlide === 'valorant') {
            resGame.removeClass('fortnite cs');
            resGame.addClass('valorant');
        }
    };

    function calcGameConvertetion() {
        var operation, coef, valRes, varResRounded;
        var valInput = $input.val();

        function showRes() {
            valRes = isNaN(valRes) ? 0 : valRes;
            varResRounded = Math.floor(valRes * 1000) / 1000;
            if (selected_game_to_index === 'cs') {
                $resGameName.text('CS: GO');
            } else {
                $resGameName.text(capitalize(selected_game_to_index));
            }
            $resVal.text(varResRounded);
        }

        // console.log(selected_game_to_index);

        function makeConvertetion() {
            operation = values[selected_game_from_index][selected_game_to_index][0];
            coef = values[selected_game_from_index][selected_game_to_index][1];
            // console.log(values[selected_game_from_index][selected_game_to_index]);
            // console.log(selected_game_to_index);
            // console.log(operation, coef);
            // console.log(selected_game_from_index, selected_game_to_index, valInput, coef);
            if (operation === 'divide') {
                valRes = valInput / coef;
                showRes();
            }
            if (operation === 'multiple') {
                valRes = valInput * coef;
                showRes();
            }
            addConvertToGameClass(selected_game_to_index, $resGameName);
        }
        function resetConvertation() {
            $resVal.text('-');
            $resGameName.text('-');
            $resGameName.removeClass('fortnite cs valorant');
        }
        // user visit converter page without preselected game
        // console.log(selected_game_to_index !== false, selected_game_from_index !== false, validateInput($input) === false);
        if (selected_game_to_index !== false && selected_game_from_index !== false && validateInput($input) === false) {
            makeConvertetion();
        } else {
            resetConvertation();
        }

        // user visit converter page with preselected game
        // function calcResPreselectedGame(game) {
        //     selected_game_from_index = game;
        //     if (selected_game_from_index === game && selected_game_to_index !== false && validateInput($input) === false) {
        //         operation = values[selected_game_from_index][selected_game_to_index][0];
        //         coef = values[selected_game_from_index][selected_game_to_index][1];
        //         if (operation === 'divide') {
        //             valRes = valInput / coef;
        //             showRes();
        //         }
        //         if (operation === 'multiple') {
        //             valRes = valInput * coef;
        //             showRes();
        //         }
        //         addConvertToGameClass(selected_game_to_index, $resGameName);

        //         // Preselected game is changed - fortnite
        //         if (selected_game_from_index === 'fortnite' && selected_game_to_index !== false && validateInput($input) === false) {
        //             makeConvertetion();
        //         } else {
        //             resetConvertation();
        //         }

        //         // Preselected game is changed - cs
        //         if (selected_game_from_index === 'cs' && selected_game_to_index !== false && validateInput($input) === false) {
        //             makeConvertetion();
        //         } else {
        //             resetConvertation();
        //         }

        //         // Preselected game is changed - valorant
        //         if (selected_game_from_index === 'valorant' && selected_game_to_index !== false && validateInput($input) === false) {
        //             makeConvertetion();
        //         } else {
        //             resetConvertation();
        //         }

        //     } else {
        //         resetConvertation();
        //     }
        // }

        // // user visit converter page with preselected game
        // if (url.includes('game=')) {
        //     calcResPreselectedGame('fortnite');
        //     calcResPreselectedGame('cs');
        //     calcResPreselectedGame('valorant');
        // }
    }

    $sectionConverter.on('click keyup', function () {
        calcGameConvertetion();
    });
    // calcGameConvertetion();

})(jQuery);
